import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CaseService {
  private url: string = environment.apiUrl;

  constructor(
    private http: HttpClient
  ) { }

  public getSurveys(): Observable<any> {
    return this.http.get(
      this.url + 'unauthenticated/surveys'
    )
  }

  public getSurveySettings(surveyId: number): Observable<any> {
    return this.http.get(
      this.url + 'unauthenticated/surveySettings', {
        params: new HttpParams().set('surveyId', surveyId.toString())
      }
    )
  }

  public nextCase(codePrefix: string, submissionId: number, organisationId: number): Observable<any> {
    return this.http.post(
      this.url + 'unauthenticated/getNextCaseCodeIncrementor', {
        codePrefix: codePrefix,
        submissionId: submissionId.toString(),
        organisationId: organisationId.toString()
      }
    )
  }

  public newCase(codePrefix: string, submissionId: number, sequenceNo: number, hashCode: string, caseCodeNote: string, groupLevelId: number): Observable<any> {
    return this.http.post(
      this.url + 'unauthenticated/validateCaseCode', {
        codePrefix: codePrefix,
        submissionId: submissionId.toString(),
        sequenceNo: sequenceNo.toString(),
        hashCode: hashCode,
        notes: caseCodeNote,
        groupLevelId: groupLevelId
      }
    )
  }

  public ipAddress(): Observable<any> {
    return this.http.get('https://api.ipify.org?format=json')
  }

  public checkCaseCode(caseCode: string): Observable<any> {
    return this.http.get(
      this.url + 'unauthenticated/checkCaseCode', {
        params: new HttpParams().set('submissionCaseCode', caseCode)
      }
    )
  }

  public caseCodeCount(submissionId: number, prefix: string): Observable<any> {
    return this.http.get(
      this.url + 'unauthenticated/' + submissionId.toString() + '/caseCodeCount', {
        params: new HttpParams().set('prefix', prefix)
      }
    )
  }

}
